export default __webpack_public_path__ + "static/media/pause-dark.e876fcc2.svg";